import { getState } from "core-web/state";

export default () => {
    const { items } = getState("basket");
    return !items || items.length === 0;
};
